inputs-complex-delivery-attachments-for-circle
  div(class="form-group row {error: opts.errors}")
    label.col-md-4.col-form-label
      | {opts.label}
    .col-md-8
      input(type="hidden" value="{opts.value}" name="{opts.name}" style="width: 100%" class="form-control")
      span.test-bar-checkbox
        input(if="{testBar}" id="{this.tagScope}.testBar" type="checkbox" checked="checked" onchange="{onChangeTestBar}")
        input(if="{!testBar}" id="{this.tagScope}.testBar" type="checkbox" onchange="{onChangeTestBar}")
      label.test-bar-label(for="{this.tagScope}.testBar")
        | 試験棒
      div.wrap.mb-1(each="{item, index in items}" class="{(item.value == '1') ? 'checked' : ''}")
        .d-flex
          span.checkbox
            input(if="{item.checked}" type="checkbox" checked="checked" onchange="{onChangeCheckbox}")
            input(if="{!item.checked}" type="checkbox" onchange="{onChangeCheckbox}")
          span.num {item.label}
          input.filename.form-control(type="text" value="{item.value}" onBlur="{onChangeText}")
  script(type="typescript").
    this.mixin('inputs.complex.delivery-attachments-for-circle')
  style(scoped).
    .test-bar-label {
      margin-left: .3rem;
    }
    .num {
      margin: .4rem .5rem 0 .5rem;
    }
    .checkbox {
      margin: .4rem 0 0 0;
    }
    .filename {
      width: 25rem;
    }
